export default __webpack_public_path__ + "static/media/proxima-nova-extra-bold.0af843cb.woff2";